import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const FORM_INITIAL_STATE = {
  'loading': false,
  'values': {
    'tasks': [],
  },
};

export const techniciansAssignmentForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHING_TASKS_BY_ORDER]: (state, action) => ({
      ...state,
      'loading': true,
      'values': {
        ...state.values,
        'tasks': [],
      },
    }),
    [ActionTypes.FETCHED_TASKS_BY_ORDER]: (state, action) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'tasks': action.response.data,
      },
    }),
    [ActionTypes.FETCHED_TASKS_BY_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'tasks': [],
      },
    }),
  })(state, action);
};
